module.exports = __webpack_public_path__ + "static/media/wash-cloth.e8746c08.svg";